import React, {Component} from 'react';
import './resume.css';

class Resume extends Component {

  componentDidMount() {
    this.setState({myRoute: this.props.match.path})
  };

  render() {
    return (
      <section className="container resume">
        <h2>PROFESSIONAL EXPERIENCE</h2>
        <div>
          <div>
            <h3>Cetera Financial Group, <br className="d-md-none"/> El Segundo, CA <br/><span>DEVELOPER UI/UX</span>
            </h3>
            <p>2010 – CURRENT</p>
          </div>

          <ul>
            <li><span>Lead development team and work in agile process using Jira</span></li>
            <li><span>Responsible for frontend UI/UX integration (Bootstrap, Sass)</span></li>
            <li><span>Developed Angular 2 components.</span></li>
            <li><span>Create wireframes storyboards & user flows.</span></li>
            <li><span>Developed boilerplate automated workflow using tool NPM scripts, Gulp/Grunt, Yeoman.</span></li>
            <li><span>Build reusable code and libraries for future use.</span></li>
            <li><span>Optimizing application for maximum speed and scalability.</span></li>
            <li><span>Supported Marketing with SEO implementation (GA, GTM), Marketing campaigns with (Salesforce, Eloqua).
            </span></li>
            <li><span>Developed CRUD in React, Node and MongoDB.</span></li>
            <li><span>Developed back-end Alfresco WCM Web API Scripts using, Freemarker templates to provide JSON, HTML, XML.
            </span></li>
            <li><span>Maintain, build content on several public sites, intranet (Liferay) and client websites.</span>
            </li>
          </ul>
          <p><strong>Development:</strong> <span>Docker (hub, cloud), AWS, GitHub, React Native (basic)</span></p>
        </div>


        <div>
          <div>
            <h3>ING Advisors,<br className="d-md-none"/> El Segundo, CA <br/><span>FRONTEND DEVELOPER</span></h3>
            <p>2008 - 2010</p>
          </div>
          <ul>
            <li><span>Managed offshore CMS backend development team for API integration.</span></li>
            <li><span>Designed and implemented frontend application to display CMS content.</span></li>
            <li><span>Developed web content for several external and Internal websites.</span></li>
            <li><span>Developed marketing campaign using WCM Oracle Stellent.</span></li>
            <li><span>Specialized in SEO</span></li>
            <li><span>Managed video streaming service integration.</span></li>
          </ul>
          <p><strong>Development:</strong> JavaScript, JQuery, Alfresco</p>
        </div>
        <div>
          <div>
            <h3>Kapa Services, <br className="d-md-none"/>Encino, CA <br/><span>CO-FOUNDER, WEBSITE DEVELOPMENT & MARKETING</span>
            </h3>
            <p>2007 - 2008</p>
          </div>
          <p className="text-normal"><span>Consultant in website development & marketing with a focus point on CMS, Wireframe design, Sitemap, designed
          CMS
          template in CSS, integrate multimedia content, create user training material and trained front/backend users.</span>
          </p>
        </div>
        <div>
          <div>
            <h3>Motion Picture Marine, <br className="d-md-none"/>Marina Del Rey, CA <br/><span>SENIOR FIELD TECHNICIAN & LEAD DEVELOPER FOR CAMERA STABILIZATION TECHNOLOGY</span>
            </h3>
            <p>1999 - 2007</p>
          </div>
          <ul>
            <li><span>Website development, email marketing campaign (newsletters)</span></li>
            <li><span>Marketing Product Manager for PR, Expo, Print</span></li>
            <li><span>Specialist in stabilizing and vibration insulation for Film & HD cameras</span></li>
            <li><span>Photographer, basic training in Film and HD cameras.</span></li>
          </ul>
        </div>
        <div>
          <div>
            <h3>McKinsey & Company, <br className="d-md-none"/>Los Angeles, CA <br/><span>SENIOR TECHNICAL BUSINESS DESIGNER</span>
            </h3>
            <p>1998 - 1999</p>
          </div>
          <ul>
            <li><span>Developed company website</span></li>
            <li><span>Prepared complete business presentations</span></li>
            <li>
              <span>Implemented, static data, statistics and time tables, flow diagrams into clear visual content.</span>
            </li>
          </ul>
        </div>
        <div>
          <div>
            <h3>McKinsey & Company, <br className="d-md-none"/>Munich, Bavaria, Germany<br/><span>SENIOR TECHNICAL BUSINESS DESIGNER</span>
            </h3>
            <p>1994 – 1998</p>
          </div>

          <ul>
            <li><span>Senior Technical Business Designer preparing complete business presentations. Create special color
              schemes,
              design visual graphics and animated sequences for various presentations.
            </span></li>
            <li><span>Provided technical support for multimedia presentations and Network Administrator, IT support for Mac
              and
              PC; Instructor for software training.
            </span></li>
          </ul>
        </div>

        <h2>EDUCATION</h2>

        <div>
          <p className="text-normal">3/1992 German Chamber of Commerce and Industry: <span>Diploma in advertising consulting.</span>
          </p>
          <p className="text-normal">1/1987 German Chamber of Commerce and Industry: <span>Diploma in industrial electronics engineering.</span>
          </p>
        </div>
        <h2 className="resume-company-subheader">SKILLS</h2>
        <div className="resume-company-section last">
          <p className="text-normal">Languages: <span>Fluent in German & English</span></p>
          <p className="text-normal">UCLA Extension Classes: <span>LAMP Stack, Linux Network Administration, Linux Network Security, Java I + II</span>
          </p>
        </div>
      </section>
    );
  };
}

export default Resume;



// WEBPACK FOOTER //
// ./src/components/resume/Resume.js